import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Row from '../Row';
import Col from '../Col';
import MessagesList from './MessagesList';
import Walkthrough from './Walkthrough';
import DocumentsList from './DocumentsList';
import WarrantyList from './WarrantyList';
import ServiceRequestList from './ServiceRequestList';
import MaintainanceList from './MaintainanceList';
import {
  fetchLatestMessages,
  clearMessages,
} from '../../store/actions/Messages';
import {
  fetchLatestServiceRequests,
  clearServiceRequests,
} from '../../store/actions/serviceRequests';
import {
  fetchLatestFaqsNotesDocuments,
  fetchMaintenanceGuide,
  clearFaqsNotesDocuments,
  onFetchLatestVideos,
} from '../../store/actions/faqsNotesDocuments';
import { fetchPropertyDetailsByProperty } from '../../store/actions/auth';
import {
  fetchPropertyWalkthrough,
  setPropertyWalkThroughFormIsVisible,
  setPropertyWalkThroughFormData,
  setPropertyWalkThroughFormStep,
  fetchConfigureTypeWalkThroughData,
} from '../../store/actions/propertyWalkThroughForm';

import {
  fetchAreasAndSubAreas,
  fetchSuiteCheckList,
} from '../../store/actions/areas';

import { selectMessages } from '../../store/selectors/Messages';
import { selectServiceRequests } from '../../store/selectors/serviceRequests';
import {
  selectAuthenticatedUser,
  selectpropertyManagerDetails,
} from '../../store/selectors/auth';
import {
  selectFaqsNotesDocuments,
  selectDocuments,
  selectFaqByIssueType,
  selectFaqs,
} from '../../store/selectors/faqsNotesDocuments';
import * as client from '../../services/client';

import './HomeOwnerDashboard.scss';
import { PATHS } from '../../common/constants';
import {
  selectPropertyWalkThroughFormData,
  selectPropertyWalkThroughFormIsVisible,
} from '../../store/selectors/propertyWalkThroughForm';
import { fetchAssetsBySuiteId } from '../../store/actions/assets';
import PropertyWalkThroughForm from '../PropertyWalkThroughForm';
import Overlay from '../Overlay';
import { fetchProperties } from '../../store/actions/properties';

import { selectAnnouncements } from '../../store/selectors/Announcements';
import {
  fetchLatestAnnouncements,
  clearAnnouncementsDone,
} from '../../store/actions/Announcements';
import { setEasyWalkThroughFormData } from '../../store/actions/easyWalkThroughForm';
import VideosList from './VideosList';
import { selectLoader } from '../../store/selectors/loader';
import { selectUserSuiteList } from '../../store/selectors/userSuites';
import Loader from '../Loader';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import { fetchCalendlyLink } from '../../store/actions/auth';
import { ScheduleWalkthroughComponent } from '../ScheduleWalkthrough/ScheduleWalktroughComponent';
import { fetchPropertyDeveloperAvailableTimes } from '../../store/actions/availableServiceTimes';
import {
  setWalkThroughStatus,
  onFetchSuiteTopFaqs,
} from '../../store/actions/suites';
import {
  onWalkthroughScheduled,
  onClearWalkthroughDone,
} from '../../store/actions/walkThroughs';
import moment from 'moment';
import { ConstructionStages } from './ConstructionStages';
import {
  fetchPropertyStages,
  clearConstructionStages,
} from '../../store/actions/HomeownerOnboardingComponent';
import { variables } from '../../Tenants';
import { selectWalkThrough } from '../../store/selectors/walkThrough';
import FaqsList from './FaqsList';
import { selectServiceRequestFormIsVisible } from '../../store/selectors/serviceRequestForm';
import { setServiceRequestFormIsVisible } from '../../store/actions/serviceRequestForm';
import ServiceRequestForm from '../ServiceRequestForm/ServiceRequestForm';
import { useBranding } from '../../branding/BrandingContextProvider';

import download from 'downloadjs';

class HomeOwnerDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warrantyList: {},
      maintenanceguide: [],
      isPlayVideo: false,
      videoObj: {},
      showOverlay: false,
      propertyData: {},
    };
  }
  async componentDidMount() {
    const {
      user,
      property,
      onFetchLatestMessages,
      onFetchLatestServiceRequests,
      onFetchLatestFaqsNotesDocuments,
      onFetchLatestVideos,
      onFetchPropertyWalkthrough,
      onFetchProperties,
      onClearWalkthroughDone,
      clearServiceRequests,
      clearConstructionStages,
      clearMessages,
      clearFaqsNotesDocuments,
      onFetchLatestAnnoucments,
      currentUserSuite,
      onFetchPropertyStages,
      onFetchSuiteTopFaqs,
    } = this.props;

    let currentUserSuiteId = currentUserSuite.id;
    let currentpropertyId = currentUserSuite.propertyId;
    let srParams = {
      propertyName: currentUserSuite.propertyName,
      propertyId: currentpropertyId,
      propertyid: currentpropertyId,
      suiteId: currentUserSuite.id,
      suite_id: currentUserSuite.id,
    };
    this.setState({ propertyData: srParams });
    await clearServiceRequests();
    onClearWalkthroughDone();
    clearMessages();
    clearConstructionStages();
    await clearFaqsNotesDocuments();
    // if(localStorage.getItem('theme') !== 'Shape') {
    onFetchLatestAnnoucments(currentUserSuiteId);
    // } else {
    //     this.props.clearAnnouncementsDone();
    // }
    onFetchPropertyStages(currentpropertyId);
    onFetchLatestMessages(currentUserSuiteId);

    onFetchLatestServiceRequests(currentUserSuiteId);
    await onFetchLatestFaqsNotesDocuments(
      currentUserSuiteId,
      'MaintenanceGuide'
    );
    onFetchLatestVideos(currentUserSuiteId);
    onFetchPropertyWalkthrough(currentUserSuiteId, user.roles[0].role.name);
    this.onFetchWarrantyStatus();
    if (property && property.propertyId) {
    } else {
      onFetchProperties(user.id, user.roles[0].role.name, false);
    }
    onFetchSuiteTopFaqs(currentUserSuiteId);
  }

  async componentDidUpdate(prevProps) {
    const { currentUserSuite: prevCurrentUserSuite } = prevProps;
    const {
      currentUserSuite,
      onFetchPropertyWalkthrough,
      clearServiceRequests,
      onFetchPropertyStages,
      user,
      onFetchSuiteTopFaqs,
    } = this.props;
    if (prevCurrentUserSuite.id !== currentUserSuite.id) {
      const {
        onFetchLatestMessages,
        onFetchLatestServiceRequests,
        onFetchLatestFaqsNotesDocuments,
        onFetchLatestVideos,
        onFetchLatestAnnoucments,
        onFetchPropertyManagerDetails,
        currentUserSuite,
      } = this.props;
      await clearServiceRequests();
      // if(localStorage.getItem('theme') !== 'Shape') {
      onFetchLatestAnnoucments(currentUserSuite.id);
      // } else {
      //     this.props.clearAnnouncementsDone();
      // }
      onFetchLatestMessages(currentUserSuite.id);
      onFetchLatestServiceRequests(currentUserSuite.id);
      await onFetchLatestFaqsNotesDocuments(
        currentUserSuite.id,
        'MaintenanceGuide'
      );
      onFetchLatestVideos(currentUserSuite.id);
      onFetchPropertyWalkthrough(currentUserSuite.id, user.roles[0].role.name);
      onFetchPropertyStages(currentUserSuite.propertyId);
      this.onFetchWarrantyStatus();
      onFetchSuiteTopFaqs(currentUserSuite.id);
      let srParams = {
        propertyName: currentUserSuite.propertyName,
        propertyId: currentUserSuite.propertyId,
        propertyid: currentUserSuite.propertyId,
        suiteId: currentUserSuite.id,
        suite_id: currentUserSuite.id,
      };
      this.setState({ propertyData: srParams });
    }
  }

  onFetchWarrantyStatus = () => {
    const { currentUserSuite } = this.props;
    client.fetchWarrantyStatus(currentUserSuite.id).then((response) => {
      if (response.ok || response.status === 200) {
        response.json().then((responseJson) => {
          this.setState({ warrantyList: responseJson });
        });
      }
    });
  };

  onDownloadDocument = (url) => {
    download(url);
  };
  handleStatus = async (data) => {
    const {
      onFetchCalendlyLink,
      user,
      onSetPropertyWalkThroughFormIsVisible,
      onSetPropertyWalkThroughFormData,
      propertyManagerDetails,
      onSetPropertyWalkThroughFormStep,
      onFetchConfigureTypeWalkThroughData,
      onFetchAreasAndSubAreas,
      onfetchAssetsBySuiteId,
      onSetEasyWalkThroughFormData,
      currentUserSuite,
    } = this.props;
    const roleName = user.roles[0].role.name;
    if (data.status === 'Review' && roleName === 'Realtor') {
      onSetPropertyWalkThroughFormIsVisible(true);
      onSetPropertyWalkThroughFormStep(3);
      onSetEasyWalkThroughFormData({
        reviewWalkThroughServiceRequestListLoading: true,
        walkThroughId: data.id,
      });
    } else {
      if (roleName !== 'Realtor') {
        onfetchAssetsBySuiteId(currentUserSuite.id);
        await onFetchCalendlyLink(propertyManagerDetails?.email);

        if (data.walkthroughType === 'Simplified') {
          if (data.status !== 'Activate') {
            onSetPropertyWalkThroughFormData({
              walkthroughType: data.walkthroughType,
              propertyId: currentUserSuite.propertyId,
              propertyName: currentUserSuite.propertyName,
              suiteId: currentUserSuite.id,
              suiteName: variables.Suite + ' ' + currentUserSuite.number,

              status: data.status,

              walkthroughId: data.id ? data.id : '',
              propertyAddress: propertyManagerDetails.addressLine1,
              propertyCity: propertyManagerDetails.city,
              propertyProvince: propertyManagerDetails.province,
              proeprtyPostalCode: propertyManagerDetails.postalCode,
              isHomeOwner: true,
              permissions: data.permissions ? data.permissions : null,
              walkthroughName: data.walkthroughName,
            });
          }
          onSetEasyWalkThroughFormData({
            homeOwnerFirstName:
              currentUserSuite.homeOwner && currentUserSuite.homeOwner.firstname
                ? currentUserSuite.homeOwner.firstname
                : '',
            homeOwnerLastName:
              currentUserSuite.homeOwner && currentUserSuite.homeOwner.lastname
                ? currentUserSuite.homeOwner.lastname
                : '',
            propertyManagerFirstName:
              currentUserSuite.propertyManager &&
              currentUserSuite.propertyManager.firstname
                ? currentUserSuite.propertyManager.firstname
                : '',
            propertyManagerLastName:
              currentUserSuite.propertyManager &&
              currentUserSuite.propertyManager.lastname
                ? currentUserSuite.propertyManager.lastname
                : '',
          });
          if (data.status === 'Review') {
            onSetEasyWalkThroughFormData({
              reviewWalkThroughServiceRequestListLoading: true,
              walkThroughId: data.id,
              type: 'Dashboard',
            });
            onSetPropertyWalkThroughFormIsVisible(true);
            onSetPropertyWalkThroughFormStep(5);
          } else if (data.status === 'Schedule') {
            this.setState({ showOverlay: true, walkthroughSelectedObj: data });
          } else if (data.status === 'Begin' && data?.schedule) {
            this.setState({ showOverlay: true, walkthroughSelectedObj: data });
          } else {
            if (
              data.status === 'Begin' ||
              data.status === 'Self-Guided Walk Through'
            ) {
              let status = {
                WalkthroughId: data.id,
                Status:
                  data.status === 'Begin'
                    ? 'In Progress'
                    : 'In Progress Home Only',
                SuiteId: data.suiteId,
              };
              this.props.setWalkThroughStatus(status);
            }
            onSetPropertyWalkThroughFormIsVisible(true);
            onSetPropertyWalkThroughFormStep(4);
          }
        } else {
          if (data.status === 'Schedule') {
            return this.setState({
              showOverlay: true,
              walkthroughSelectedObj: data,
            });
          } else if (data.status === 'Begin' && data?.schedule) {
            this.setState({ showOverlay: true, walkthroughSelectedObj: data });
          } else if (
            data.status === 'Begin' ||
            data.status === 'Guided Walk Through'
          ) {
            this.props.history.push(
              PATHS.SUITES_VIEW.replace(
                ':id',
                currentUserSuite.propertyId + '&' + currentUserSuite.id
              )
            );
          } else if (data.status === 'Review') {
            onSetEasyWalkThroughFormData({
              reviewWalkThroughServiceRequestListLoading: true,
              walkThroughId: data.id,
              type: 'Dashboard',
            });
            onSetPropertyWalkThroughFormIsVisible(true);
            onSetPropertyWalkThroughFormStep(3);
          } else if (
            data.status === 'In Progress' ||
            data.status === 'Self-Guided Walk Through' ||
            data.status === 'In Progress Home' ||
            data.status === 'In Progress Home Only'
          ) {
            onSetEasyWalkThroughFormData({
              homeOwnerFirstName:
                currentUserSuite.homeOwner &&
                currentUserSuite.homeOwner.firstname
                  ? currentUserSuite.homeOwner.firstname
                  : '',
              homeOwnerLastName:
                currentUserSuite.homeOwner &&
                currentUserSuite.homeOwner.lastname
                  ? currentUserSuite.homeOwner.lastname
                  : '',
              propertyManagerFirstName:
                currentUserSuite.propertyManager &&
                currentUserSuite.propertyManager.firstname
                  ? currentUserSuite.propertyManager.firstname
                  : '',
              propertyManagerLastName:
                currentUserSuite.propertyManager &&
                currentUserSuite.propertyManager.lastname
                  ? currentUserSuite.propertyManager.lastname
                  : '',
            });
            onSetPropertyWalkThroughFormIsVisible(true);
            onSetPropertyWalkThroughFormData({
              walkthroughType: data.walkthroughType,
              propertyId: currentUserSuite.propertyId,
              propertyName: currentUserSuite.propertyName,
              suiteId: currentUserSuite.id,
              suiteName: variables.Suite + ' ' + currentUserSuite.number,

              status: data.status,

              walkthroughId: data.id ? data.id : '',
              propertyAddress: propertyManagerDetails.addressLine1,
              propertyCity: propertyManagerDetails.city,
              propertyProvince: propertyManagerDetails.province,
              proeprtyPostalCode: propertyManagerDetails.postalCode,
              isHomeOwner: true,
              permissions: data.permissions ? data.permissions : null,
              walkthroughName: data.walkthroughName,
            });
            onSetPropertyWalkThroughFormStep(2);
          }
        }
      }
    }
  };

  async onWalkthroughScheduled(data) {
    const { user, setWalkThroughStatus, suite, propertyManagerDetails } =
      this.props;
    const filteredWalkThrough = this.state.walkthroughSelectedObj;
    let params = {
      WalkthroughId: filteredWalkThrough?.id,
      PropertymanagerId:
        propertyManagerDetails?.propertyManager &&
        propertyManagerDetails.propertyManager?.id
          ? propertyManagerDetails?.propertyManager.id
          : '',
      UserId: user?.id,
      HomeownerId: user?.id,
    };
    if (
      propertyManagerDetails?.calendlyLink &&
      propertyManagerDetails?.calendlyAPIKey
    ) {
      params['EventId'] = data;
    } else {
      let date = moment(data, 'YYYY-MM-DD HH:mm A').toDate();
      params['ScheduledAt'] = date;
      params['ScheduledDay'] = moment(date).format('dddd');
      params['ScheduledTime'] = moment(date).format('hh:mm A');
    }
    onWalkthroughScheduled(params);

    //update status

    let status = {
      walkthroughType: filteredWalkThrough.walkthroughType,
      WalkthroughId: filteredWalkThrough.id,
      SuiteId: filteredWalkThrough.suiteId,
      UserId: user.id,
      Role: user.roles[0].role.name,
      Signature: '',
      Status: 'Begin',
      PropertyName: propertyManagerDetails?.propertyName,
      SuiteName: filteredWalkThrough.suiteNumber,
      PropertymanagerId:
        propertyManagerDetails?.propertyManager &&
        propertyManagerDetails?.propertyManager?.id
          ? propertyManagerDetails?.propertyManager.id
          : '',
      ActionUrl:
        'app/suites/' +
        propertyManagerDetails?.propertyId +
        '&' +
        filteredWalkThrough.suiteId,
    };
    let suiteUpdateData = suite;
    suiteUpdateData = { ...suite, status: 'Begin' };
    await setWalkThroughStatus(status, suiteUpdateData);
    setTimeout(() => this.setState({ showOverlay: false }), 2000);
  }
  render() {
    const {
      user,
      propertyManagerDetails,
      history,
      messages,
      serviceRequests,
      documents,
      propertyWalkThroughData,
      propertyWalkThroughFormIsVisible,
      onFetchPropertyWalkthrough,
      propertyVideos,
      currentUserSuite,
      prloader,
      onFetchAvailableServiceTimes,
      availableServiceTimes,
      constructionStages,
      walkThroughs,
      faqs,
      tabSelections,
      serviceRequestFormIsVisible,
      onSetServiceRequestFormIsVisible,
    } = this.props;
    const { allowedTabList } = tabSelections;
    const { branding } = useBranding();
    let maintenanceguide = [];
    this.props.faqsNotesDocuments.map((item, i) => {
      if (item.type === 'MAINTENANCEGUIDE') {
        maintenanceguide.push(item);
      }
    });
    let theme = localStorage.getItem('theme');

    const walkthroughsList =
      walkThroughs && walkThroughs.length > 0
        ? walkThroughs.filter(
            (wd) =>
              !(
                wd.status === 'Configure' ||
                (wd.status === 'In Progress' &&
                  wd.walkthroughType !== 'Simplified') ||
                wd.status === 'Activate'
              )
          )
        : [];

    const tiles = [
      {
        localLabel: 'Messages & Announcements',
        content: (
          <>
            <Col xs="12" md="6">
              <MessagesList
                data={messages}
                datta={this.props.announcements}
                history={history}
                currentUserSuite={currentUserSuite}
              />
            </Col>
          </>
        ),
      },

      {
        localLabel: 'WalkThrough',
        content: (
          <>
            {walkthroughsList && walkthroughsList.length > 0 && (
              <Col xs="12" md="6">
                <Walkthrough
                  walkthroughData={
                    walkthroughsList.length > 0 ? walkthroughsList : []
                  }
                  history={history}
                  handleStatus={this.handleStatus}
                  currentUserSuite={currentUserSuite}
                  propertyManagerDetails={propertyManagerDetails}
                />
              </Col>
            )}
          </>
        ),
      },

      {
        localLabel: 'Manuals & Documents',
        content: (
          <>
            <Col xs="12" md="6">
              <DocumentsList
                data={documents}
                history={history}
                onDownloadDocument={this.onDownloadDocument}
              />
            </Col>
          </>
        ),
      },

      {
        localLabel: branding.text.serviceRequest + 's',
        content: (
          <>
            <Col xs="12" md="6">
              <ServiceRequestList
                unitId={propertyManagerDetails?.unitId}
                onSetServiceRequestFormIsVisible={
                  onSetServiceRequestFormIsVisible
                }
                data={serviceRequests}
                history={history}
                currentUserSuite={currentUserSuite}
              />
            </Col>
          </>
        ),
      },

      {
        localLabel: 'WalkThrough',
        content: (
          <>
            <Col xs="12" md="6">
              <WarrantyList
                data={this.state.warrantyList}
                history={history}
                propertyManagerDetails={propertyManagerDetails}
                currentUserSuite={currentUserSuite}
              />
            </Col>
          </>
        ),
      },

      {
        localLabel: 'Maintenance Reminders',
        content: (
          <>
            <Col xs="12" md="6">
              <MaintainanceList
                data={maintenanceguide}
                history={history}
                currentUserSuite={currentUserSuite}
              />
            </Col>
          </>
        ),
      },

      {
        localLabel: 'Manuals & Documents',
        content: (
          <>
            {propertyVideos && propertyVideos.length > 0 && (
              <Col xs="12" md="6">
                <VideosList
                  data={propertyVideos}
                  history={history}
                  playVideo={(data) => this.props.onChange(data)}
                  onClose={() => this.props.onClose()}
                />
              </Col>
            )}
          </>
        ),
      },

      {
        localLabel: 'FAQs',
        content: (
          <>
            {faqs && faqs.length > 0 && (
              <Col xs="12" md="6">
                <FaqsList currentUserSuite={currentUserSuite} faqs={faqs} />
              </Col>
            )}
          </>
        ),
      },
    ];
    let tilesComp = allowedTabList.map((item) => {
      let tenantObj = tiles.filter((tn) => tn.localLabel === item.name)[0];
      return tenantObj;
    });
    let filterTilesComp = tilesComp.filter(function (element) {
      return element !== undefined;
    });

    let tilesComponent = filterTilesComp.map((item) => {
      return item.content;
    });

    return (
      <>
        {prloader ? <Loader center={true} /> : null}
        <div>
          <div className="homeDasboard">
            <Row>
              <div className="homeDasboard__tilesView">
                {constructionStages && constructionStages.length > 0 && (
                  <div className="homeDasboard__stages">
                    <ConstructionStages
                      constructionStages={constructionStages}
                    />
                    <br />
                  </div>
                )}
                <div className="homeDasboard__tiles">
                  <div className="homeDasboard__tilesbody">
                    <Row>
                      {tilesComponent.length === 0 ? (
                        <Col xs="12" md="12" lg="12">
                          No any permission granted for selected suite.
                        </Col>
                      ) : (
                        tilesComponent
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </Row>
          </div>
          <Overlay
            showOverlay={propertyWalkThroughFormIsVisible}
            content={
              <PropertyWalkThroughForm
                onClose={() => {
                  onFetchPropertyWalkthrough(
                    currentUserSuite.id,
                    user.roles[0].role.name
                  );
                }}
              />
            }
          />
          <Overlay
            showOverlay={this.state.showOverlay}
            content={
              <ScheduleWalkthroughComponent
                suite={currentUserSuite}
                property={propertyManagerDetails}
                scheduling_url={propertyManagerDetails?.calendlyLink}
                hasCalendlyKey={
                  propertyManagerDetails?.calendlyAPIKey ? true : false
                }
                onEventScheduled={(data) => {
                  this.onWalkthroughScheduled(data);
                }}
                onClose={() => {
                  this.setState({ showOverlay: false });
                }}
                onFetchAvailableServiceTimes={onFetchAvailableServiceTimes}
                availableServiceTimes={availableServiceTimes}
                user={user}
                suiteNumber={
                  propertyWalkThroughData?.walkthroughData?.suiteNumber
                }
                from={'Dashboard'}
              />
            }
          />
        </div>

        <Overlay
          showOverlay={serviceRequestFormIsVisible}
          content={
            <ServiceRequestForm
              from={'HomeOwnerDashboard'}
              propertyData={this.state.propertyData}
              propertyDisabled={true}
            />
          }
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  user: selectAuthenticatedUser(state),
  propertyManagerDetails: selectpropertyManagerDetails(state),
  messages: selectMessages(state),
  serviceRequests: selectServiceRequests(state),
  documents: selectDocuments(state),
  faqsNotesDocuments: selectFaqsNotesDocuments(state),
  propertyWalkThroughData: selectPropertyWalkThroughFormData(state),
  propertyWalkThroughFormIsVisible:
    selectPropertyWalkThroughFormIsVisible(state),
  announcements: selectAnnouncements(state),
  propertyVideos: state.PropertyVideos,
  loader: selectLoader(state),
  prloader: selectPRLoader(state),
  userSuiteList: selectUserSuiteList(state),
  availableServiceTimes: state.availableServiceTimes,
  constructionStages: state.constructionStages,
  walkThroughs: selectWalkThrough(state),
  faqs: selectFaqs(state),
  tabSelections: state.tabSelections,
  serviceRequestFormIsVisible: selectServiceRequestFormIsVisible(state),
});
const maptDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clearServiceRequests: clearServiceRequests,
      clearMessages: clearMessages,
      clearFaqsNotesDocuments: clearFaqsNotesDocuments,
      onFetchPropertyManagerDetails: fetchPropertyDetailsByProperty,
      onFetchLatestAnnoucments: fetchLatestAnnouncements,
      onFetchLatestMessages: fetchLatestMessages,
      onFetchLatestServiceRequests: fetchLatestServiceRequests,
      onFetchLatestFaqsNotesDocuments: fetchLatestFaqsNotesDocuments,
      onFetchLatestVideos: onFetchLatestVideos,
      onFetchMaintenanceGuide: fetchMaintenanceGuide,
      onFetchPropertyWalkthrough: fetchPropertyWalkthrough,
      onFetchSuiteCheckList: fetchSuiteCheckList,
      onFetchAreasAndSubAreas: fetchAreasAndSubAreas,
      onSetPropertyWalkThroughFormIsVisible:
        setPropertyWalkThroughFormIsVisible,
      onSetPropertyWalkThroughFormData: setPropertyWalkThroughFormData,
      onSetPropertyWalkThroughFormStep: setPropertyWalkThroughFormStep,
      onFetchConfigureTypeWalkThroughData: fetchConfigureTypeWalkThroughData,
      onfetchAssetsBySuiteId: fetchAssetsBySuiteId,
      onFetchProperties: fetchProperties,
      onSetEasyWalkThroughFormData: setEasyWalkThroughFormData,
      onFetchCalendlyLink: fetchCalendlyLink,
      onFetchAvailableServiceTimes: fetchPropertyDeveloperAvailableTimes,
      onWalkthroughScheduled,
      setWalkThroughStatus,
      onFetchPropertyStages: fetchPropertyStages,
      clearConstructionStages: clearConstructionStages,
      clearAnnouncementsDone,
      onClearWalkthroughDone: onClearWalkthroughDone,
      onFetchSuiteTopFaqs,
      onSetServiceRequestFormIsVisible: setServiceRequestFormIsVisible,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  maptDispatchToProps
)(HomeOwnerDashboard);
